<template>

  <div class="row">
	 
    <div class="col-xl-12">
      <h4 class="title">Request Messages</h4>
      <p class="category">
     Latest messages sent to you by clients.
      </p>
    </div>
    
    
    
        <div class="card">
   		
          <div class="card-body table-responsive table-full-width">
          	
			<el-table :data="messages" @row-click="goToTask">
			 <el-table-column label="Company" property="entity_name"  min-width=200></el-table-column>
             <el-table-column label="Message" property="message"  min-width=450></el-table-column>
             <el-table-column label="Sent At" property="created_at_str"  min-width=220></el-table-column>
              
            </el-table>
				
				
				
          </div>
        </div>
        
        
    
   
  
  </div>
</template>
<script>
  import Vue from 'vue'
  
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import users from './users'
  
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
     
    
    data () {
      return {
      	messages:[],
      	tableTd:'',

      
      }
    },
    mounted() {
    	  swal.showLoading();
     	  let uri = this.$base_url+'/api/v1/tasks/get/all_req_messages';
		  ApiService.get(uri).then(response => {
		  		this.messages = response.data.messages;
		  		 swal.close();
		  
		  });
    },
    methods: {
      goToTask(row){
      	 var tid = 0;
      	 if(row.task_id){
      	 	tid = row.task_id
      	 }
      	 this.$router.push( '/edit-task/'+tid+'/entity/'+row.entity_id)  
      },
      
    }
  }
</script>
<style lang="scss">

  
</style>
